import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';

import smoothscroll from 'smoothscroll-polyfill';
// kick off the polyfill!
smoothscroll.polyfill();

var Flickity = require('flickity');
global.Flickity = Flickity;
require('flickity-imagesloaded');
require('flickity-as-nav-for');
require('flickity-fade');
import 'flickity/css/flickity.css';

import SectionContainer from '../sections/section-container';

import Collapsible from '../components/collapsible';
import Modal from '../components/modal';
import Responsive from '../tools/responsive';

import LoadingBar from '../tools/loading-bar';
import Popover from '../components/popover';
import CartSection from '../components/cart-section';

import HeaderSection from '../sections/header';
import SidebarMenuSection from '../components/sidebar-menu';
import NewsletterPopupSection from '../sections/newsletter-popup-section';
// import QuizSection from '../sections/quiz-section'

import '../components/smooth-scroll';
import '../components/modal';
import '../components/collapsible';
import '../components/carousel';
import '../components/popup';
import '../components/animations';
import '../components/iframe';
import '../components/mediabox';
import '../components/expandable';

import $ from 'jquery';

global.$ = global.jQuery = $;

global._defineProperty = (obj, key, value) => {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
};

import '../components/cart';

// import '../tools/breakpoints'

import '../../styles/theme.scss';
import '../../styles/static/tailwind.scss';

// Apply a specific class to the html element for browser support of cookies.
if (window.navigator.cookieEnabled) {
  document.documentElement.className =
    document.documentElement.className.replace(
      'supports-no-cookies',
      'supports-cookies'
    );
}

// First, we register all plugins thate are used for all pages
new Collapsible();
new Modal();
new Responsive();
// if (window.theme.template !== 'password' && window.theme.template !== 'gift_card') {
//   new LoadingBar();
// }

document.querySelectorAll('.popover').forEach(function (popover) {
  if (popover.classList.contains('optionSelector')) {
    return false;
  }
  new Popover(popover, {
    showOverlay: true,
  });
});

// register all plugins that are used for all pages
if (
  window.theme.template !== 'password' &&
  window.theme.template !== 'gift_card'
) {
  new LoadingBar();
}

// instantiate specific sections that may appear in all pages
global.sections = new SectionContainer();

sections.register('header', HeaderSection);
sections.register('sidebar-menu', SidebarMenuSection);
sections.register('cart', CartSection);
sections.register('newsletter-popup', NewsletterPopupSection);
// sections.register('quiz', QuizSection);
